<template>
  <div
    class="modal fade new-modal"
    tabindex="-1"
    :ref="nameForAction"
    data-bs-backdrop="static"
  >
    <div
      class="modal-dialog position-relative"
      :class="[centered === false ? '' : 'modal-dialog-centered', defineSize()]"
    >
      <div
        v-if="stateLoading"
        class="position-absolute wp-100 h-100 d-flex justify-content-center align-items-center bg-white"
        style="top: 0; left: 0; z-index: 500"
      >
        <svg class="spinner" viewBox="0 0 50 50">
          <circle
            class="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke-width="5"
          ></circle>
        </svg>
      </div>
      <div
        class="modal-base-content modal-content"
        :style="{ 'min-height': `${minHeight}px` }"
      >
        <div class="modal-base-content__header">
          <slot name="modal-header"></slot>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-content-dynamic">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'
import { mapActions, mapState, mapMutations } from 'vuex'
import EventBus from '@/event-bus.js'
// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  props: {
    nameForAction: {
      type: String
    },
    modalName: {},
    centered: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    size: {
      type: String,
      default: ''
    },
    minHeight: {
      type: Number
    },
    stateLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      thisModal: null
    }
  },
  mounted() {
    this.thisModal = new Modal(this.$refs[this.nameForAction])
    EventBus.$on('openModal', (payload) => {
      if (payload.nameForAction === this.nameForAction) {
        this.thisModal.show()
      }
    })
    EventBus.$on('closeModal', (payload) => {
      if (payload.nameForAction === this.nameForAction) {
        this.thisModal.hide()
        //
      }
    })
    this.$refs[this.nameForAction].addEventListener('hide.bs.modal', () => {
      this.$emit('closeModal', { nameForAction: this.nameForAction })
    })
  },
  beforeDestroy() {
    EventBus.$off('openModal')
    EventBus.$off('closeModal')
  },
  methods: {
    defineSize() {
      switch (this.size) {
        case 'sm':
          return 'modal-sm'
        case 'lg':
          return 'modal-lg'
        case 'xl':
          return 'modal-xl'
        case 'xxl':
          return 'modal-xxl'
      }
      return
    }
  }
}
</script>
